import styled from 'styled-components';
import { color, container, fontSize, fontWeight, screen, spacing } from 'theme';

export const StyledWrapper = styled.div`
  background-color: ${color('midnight_100')};
`;

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  padding: ${spacing('xl2')} ${spacing('md')};
  margin: auto;
`;

export const StyledList = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: ${spacing('xl')};
  margin: ${spacing('xl2')} 0;

  @media (min-width: ${screen('md')}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('md')};

  @media (min-width: ${screen('lg')}) {
    flex-direction: row;
    align-items: center;
    gap: ${spacing('lg')};
  }
`;

export const StyledImage = styled.img`
  display: block;
  width: 12.5rem;
  height: 12.5rem;
`;

export const StyledContent = styled.div`
  display: flex;
  gap: ${spacing('md')};
  flex-direction: column;
  align-items: flex-start;
  font-size: ${fontSize('md')};
  line-height: 1.5;

  p {
    margin: 0;
  }
`;

export const StyledTitle = styled.h4`
  font-size: ${fontSize('xl')};
  font-weight: ${fontWeight('black')};
  margin: 0;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl2')};
  }
`;
